import product_list from './product_list';
import product_detail from './product_detail';
import promotion_page from './promotion_page';
import order_detail from './order_detail';
import order_confirm from './order_confirm';
import category from './category';
import cart from './cart';
import checkout from './checkout';
import eventMetaMap from '../../../constants/slEventBusEventNames';
import { transformCartEventData } from './transform';

// Schema for all supported pages
const all = {
  functions: [
    {
      name: 'getMerchantId',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'merchantId',
      },
    },
    {
      name: 'getLoadedCurrency',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'loadedCurrency',
      },
    },
    {
      name: 'getCurrentPageIdentifier',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'pageIdentifier',
      },
    },
    {
      name: 'getCurrentThemeKey',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'themeKey',
      },
    },
    {
      name: 'getLoadedLanguage',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'loadedLanguage',
      },
    },
    {
      name: 'getCookieConsent',
      type: 'angularFunc',
      options: {
        source: 'cookieConsentService',
        key: 'getAllCookieConsents',
      },
    },
    // Metafield Values
    {
      name: 'getMetafieldValues',
      type: 'nativeFunc',
      options: {
        source: 'MetafieldValuesService',
        key: 'getMetafieldValues',
        includeAppId: true,
      },
    },
  ],
  events: [
    {
      incomingEvent: eventMetaMap.general.currencyChanged,
      sdkEvent: 'currency.changed',
    },
    {
      incomingEvent: 'cart.itemAdded',
      sdkEvent: 'cart.update',
      transform: (data) => transformCartEventData(data),
    },
    {
      incomingEvent: 'cart.itemUpdated',
      sdkEvent: 'cart.update',
      transform: (data) => transformCartEventData(data),
    },
    {
      incomingEvent: 'cart.itemRemoved',
      sdkEvent: 'cart.update',
      transform: (data) => transformCartEventData(data),
    },
  ],
};

// Should use page identifier as the key
export default {
  all,
  cart,
  category,
  checkout,
  product_list,
  product_detail,
  promotion_page,
  order_detail,
  order_confirm,
};
